module.exports = __webpack_public_path__ + "img/img_06.20a2a1d7.png";